export default __webpack_public_path__ + "static/media/logo_commu_agglo_lens_lievin.dbb5494c.png";